import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompleteSignupComponent } from 'src/app/modules/realtor/components/complete-signup/complete-signup.component';
import { AuthenticatorComponent } from './components/authenticator/authenticator.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';

const auth_routes: Routes = [
  {path: 'completeSignUp', component: CompleteSignupComponent },
  {path: 'signIn', component: AuthenticatorComponent },
  {path: 'signUp', component: SignUpComponent },
  {path: 'forgotPassword', component: AuthenticatorComponent },
  {path: 'requireNewPassword', component: AuthenticatorComponent },
  {path: 'confirmSignUp', component: AuthenticatorComponent},
  {path: 'confirmUser', component: AuthenticatorComponent}
];

@NgModule({
  imports: [RouterModule.forChild(auth_routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
